module.exports = __webpack_public_path__ + "static/media/appscreen-img.12e5a8fe.png";